/* eslint-disable prettier/prettier */
/* eslint-disable */

import { connectReducers } from '../../utils';

import { FAILURE, REQUEST, SUCCESS } from '../../actions/utils';

import { IAdminFunctionSettingResponse } from '../../api/types';

import genericReducers from '../genericReducer';
import { GET_ADMIN_FUNCTION_SETTINGS } from '../../actions';

import { IReducers } from '..';

export type AdminFunctionSettingsState = IAdminFunctionSettingResponse;

const initialState = {} as IAdminFunctionSettingResponse;
const generic = genericReducers<AdminFunctionSettingsState>();
// TODO В текущем состоянии этот редьюсер может сохранять только 1 тип настройки админа (Search)
// нужно либо переделать редьюсер, либо переименовать в adminSearchFunctionSetting
const adminFunctionSettings: IReducers<AdminFunctionSettingsState> = {
  [GET_ADMIN_FUNCTION_SETTINGS[REQUEST]]: generic.get.request,
  [GET_ADMIN_FUNCTION_SETTINGS[SUCCESS]]: generic.get.success,
  [GET_ADMIN_FUNCTION_SETTINGS[FAILURE]]: generic.get.failure,
};

export default connectReducers(initialState, adminFunctionSettings);
